import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { lendingEasyConfig } from '../../../environments/environment';
import { LoginService } from '../../service/login.service';

@Component({
    selector: 'app-lending-easy',
    template: ''
})
export class LendingEasyComponent implements OnInit {
  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(async (params) => {
      const inApp = params['inApp'];
      if (inApp) {
        lendingEasyConfig.redirectUri =
          lendingEasyConfig.redirectUri + '?inApp=true';
      }
    });
  }

  ngOnInit(): void {
    this.loginService.login(lendingEasyConfig);
  }
}
